<template>
  <div class="h-100">
    <Header/>
    <div class="tab-content content-height" :class="isMobile ? 'suggestions-tab-content-mobile' : 'suggestions-tab-content'" id="myTabContent">
      <div class="tab-pane fade show active h-100" role="tabpanel" aria-labelledby="all-tab">
        <div class="card">
          <div class="card-body p-0">
            <div class="row w-100 m-0">
              <div class="col-12 tenders-list p-0">
                <div class="d-flex p-3">
                  <div class="col-2 p-0 btn-group dropright show p-0">
                    <button
                        type="button"
                        @click="() => {$router.push('/timeless-tenders/buy/add')}"
                        class="btn btn-primary"
                    >
                      <i class="fas fa-plus mr-1"></i>
                      <span>Ավելացնել անժամկետ տենդերներ</span>
                    </button>
                  </div>
                </div>
                <div class="d-flex flex-wrap gap-2 padding-r-10 padding-l-10 padding-t-20 padding-b-20">
                  <tender-card :tender="tender" @refreshList="refreshList" :can-favorite="false" :can-edit="true" v-for="tender in tenders" :key="tender.id"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <tender-rows-modal />
    <report-modal />
    <members-modal />
  </div>
</template>
<script>
  import ReportModal from './modals/ReportModal.vue'
  import MembersModal from './modals/MembersModal.vue'
  import TenderRowsModal from '../../../participant/tenders/modals/TenderRowsModal.vue'
  import isMobile from '@/mixins/isMobileView'
  import Header from '../header.vue'
  import TenderCard from '@/components/timelessTenders/tenderCard.vue'

  export default {
    components: { TenderCard, Header, ReportModal, MembersModal, TenderRowsModal },
    mixins: [isMobile],
    data() {
      return {
        dateNow: new Date(),
        backendUrl: process.env.VUE_APP_URL,
        tenders: [],
        columns: [
          'password',
          'title',
          'products',
          'opening_finish_date',
          'price',
          'region',
          'type',
          'invitation',
          'edit',
          'participants_count'
        ],
      }
    },
    computed: {
      currentPlan() {
        return this.$store.getters['procurement/currentPlan']
      },
      locale() {
        return this.$store.getters['user/locale']
      },
      me() {
        return this.$store.getters['user/me']
      }
    },
    mounted() {
      this.refreshList();
    },
    methods: {
      selectPage(event){
        this.$router.push(event.target.value)
      },
      refreshList(){
        if (this.me.id === 6798){
          this.$client.get('admin/timeless-tenders').then(({data}) => {
            this.tenders = data.data;
          })
        } else {
          this.$client.get('manager/timeless-tenders').then(({data}) => {
            this.tenders = data.data;
          })
        }
      },
      deleteTender(id){
        this.$client.delete(`timeless-tenders/${id}`).then(({data}) => {
          this.$client.get('manager/timeless-tenders').then(({data}) => {
            this.tenders = data.data;
          })
        })
      }
    },
  }
</script>
